import React, { useState, useRef, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import LayoutWithSidebars from '../components/LayoutWithSidebars';
import Dashboard from '../components/Dashboard';
import { database } from '../supabase';


const Main = () => {
    const [documents, setDocuments] = useState([]);
    const [currentDocumentId, setCurrentDocumentId] = useState(null);
    const dashboardRef = useRef();
    const { user, loading: authLoading, authInitialized } = useAuth();

    const toggleFlashcards = () => {
        if (dashboardRef.current) {
            dashboardRef.current.toggleFlashcards();
        }
    };

    const toggleQuiz = () => {
        if (dashboardRef.current) {
            dashboardRef.current.toggleQuiz();
        }
    };

    const toggleChat = () => {
        if (dashboardRef.current) {
            dashboardRef.current.toggleChat();
        }
    };


    const handleDocumentsUpdate = (newDocuments) => {
        console.log('Main component received documents:', newDocuments);
        setDocuments(newDocuments);
    };

    // Get current document ID from Dashboard
    const getCurrentDocumentId = () => {
        if (dashboardRef.current) {
            const docId = dashboardRef.current.getCurrentDocumentId();
            setCurrentDocumentId(docId);
            return docId;
        }
        return null;
    };

    // Update current document ID periodically
    useEffect(() => {
        const interval = setInterval(() => {
            getCurrentDocumentId();
        }, 1000); // Check every second

        return () => clearInterval(interval);
    }, []);

    // Debug effect to see documents state changes
    useEffect(() => {
        console.log('Main component documents state changed:', documents);
    }, [documents]);

    // Stripe: ensure Supabase user has stripe_customer_id (e.g. users who signed up before billing was on)
    useEffect(() => {
        if (!user) return;
        database.ensureStripeCustomerLinked(user).catch(() => {});
    }, [user]);

    // Show loading state while authentication is being checked
    if (authLoading) {
        return (
            <div className="main-layout">
                <div className="loading-container">
                    <div className="loading-spinner"></div>
                    <p>Loading...</p>
                </div>
            </div>
        );
    }

    // Only redirect to landing if not authenticated AND auth is fully initialized
    // Check if we're in the middle of a redirect process by looking at URL params
    if (!user && authInitialized) {
        // Check if this is a redirect from Google (URL might contain auth params)
        const urlParams = new URLSearchParams(window.location.search);
        const hasAuthParams = urlParams.has('code') || urlParams.has('state') || 
                             window.location.hash.includes('access_token') ||
                             window.location.hash.includes('id_token');
        
        if (hasAuthParams) {
            // We're in the middle of a redirect, show loading instead of redirecting
            return (
                <div className="main-layout">
                    <div className="loading-container">
                        <div className="loading-spinner"></div>
                        <p>Completing sign-in...</p>
                    </div>
                </div>
            );
        } else {
            // No auth params, safe to redirect to landing
            window.location.href = '/';
            return null;
        }
    }

    return (
        <LayoutWithSidebars
            documents={documents}
            currentDocumentId={currentDocumentId}
            onDocumentsUpdate={handleDocumentsUpdate}
            toggleFlashcards={toggleFlashcards}
            toggleQuiz={toggleQuiz}
            toggleChat={toggleChat}
            showBackButton={false}
        >
            <Dashboard 
                ref={dashboardRef}
            />
        </LayoutWithSidebars>
    );
}

export default Main;